export const categories = [
  {
    slug: "society",
    name: "社会",
    description: "聚焦民生、社区与公共安全领域的热点事件，追踪事实与真相。",
  },
  {
    slug: "politics",
    name: "政治",
    description: "关注政策执行、监督问责与公共事务的动态与进展。",
  },
  {
    slug: "economy",
    name: "经济",
    description: "追踪市场、金融与企业经营中的风险信号与变化趋势。",
  },
  {
    slug: "breaking",
    name: "突发",
    description: "第一时间呈现突发事件现场与最新进展，持续更新。",
  },
  {
    slug: "exclusive",
    name: "独家",
    description: "只有 911爆料 掌握的独家线索、内部资料与深度调查。",
  },
];